var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 122,
    viewBox: "0 0 106 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3976 59.7395C93.2428 59.8939 93.1199 60.0777 93.036 60.2801C92.9521 60.4825 92.9089 60.6997 92.9089 60.919C92.9089 61.1383 92.9521 61.3554 93.036 61.5578C93.1199 61.7603 93.2428 61.944 93.3976 62.0984L105.295 74.059V90.2612C105.296 90.555 105.219 90.8437 105.072 91.0979C104.926 91.3521 104.715 91.5627 104.461 91.7083L79.1562 106.332V15.5L104.463 30.137C104.716 30.2826 104.927 30.4931 105.073 30.7469C105.219 31.0008 105.295 31.289 105.295 31.5822V47.777L93.3976 59.7395Z",
    fill: "#00E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0722 7.93577V113.898L53.828 120.975C53.5765 121.119 53.2917 121.196 53.002 121.196C52.7122 121.196 52.4274 121.119 52.1759 120.975L39.9336 113.896V7.9376L52.1777 0.855367C52.4289 0.709566 52.7138 0.632812 53.0038 0.632812C53.2938 0.632812 53.5787 0.709566 53.8299 0.855367L66.0722 7.93577Z",
    fill: "#00E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54423 30.137L26.8531 15.5V106.332L1.54423 91.701C1.29013 91.5556 1.07893 91.3451 0.932192 91.0908C0.785454 90.8366 0.708432 90.5478 0.708987 90.2538V74.0627L12.6062 62.0984C12.761 61.944 12.8839 61.7603 12.9678 61.5578C13.0517 61.3554 13.0949 61.1383 13.0949 60.919C13.0949 60.6997 13.0517 60.4825 12.9678 60.2801C12.8839 60.0777 12.761 59.8939 12.6062 59.7395L0.708987 47.777V31.5822C0.709323 31.2891 0.786339 31.0013 0.932304 30.7476C1.07827 30.494 1.28804 30.2834 1.54056 30.137",
    fill: "#00E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWenLogo);
export default __webpack_public_path__ + "static/media/wen-logo.6799ced836b93f3fc2f0446393bb16cc.svg";
export { ForwardRef as ReactComponent };